import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useLenis } from "@/hooks/useLenis";
import Home from "@/pages/Home";
import BookAssessment from "@/pages/BookAssessment";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function LenisWrapper({ children }) {
  useLenis();
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LenisWrapper>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/book" element={<BookAssessment />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </LenisWrapper>
        <Toaster position="bottom-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
